module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_07.ef1f9fc1.png";